__turbopack_context__.v({
  "Breadcrumbs": "m5byuq_Breadcrumbs",
  "Breadcrumbs__Container": "m5byuq_Breadcrumbs__Container",
  "Breadcrumbs__Icon": "m5byuq_Breadcrumbs__Icon",
  "Breadcrumbs__Item": "m5byuq_Breadcrumbs__Item",
  "Breadcrumbs__Link": "m5byuq_Breadcrumbs__Link",
  "Breadcrumbs__Link--Active": "m5byuq_Breadcrumbs__Link--Active",
  "Breadcrumbs__List": "m5byuq_Breadcrumbs__List",
});
